import { ImgHTMLAttributes } from "react";

type Props = ImgHTMLAttributes<HTMLImageElement>;

export default function Image(props: Props) {
  const { src, ...rest } = props;

  if (!src) {
    return null;
  }

  return <img src={src} {...rest} />;
}
